/* Native product-section shortcuts. No requests, product data cache or polling. */
(function () {
  'use strict';
  if (customElements.get('saber-product-navigation')) return;
  const content = {
    'frequently-bought': '.product-recommendation-list-row-item',
    'complete-job': '.ss-job__card:not([hidden])',
    related: 'product-card',
    'recently-viewed': 'product-card'
  };
  class ProductNavigation extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.scope = document.getElementById('MainContent') || this.closest('main') || document.body;
      this.links = [...this.querySelectorAll('[data-product-nav-link]')];
      this.onChange = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
      };
      this.observer = new MutationObserver(this.onChange);
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-product-nav-state'] });
      this.onClick = event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !this.contains(link)) return;
        const target = link.dataset.productNavLink ? this.target(link.dataset.productNavLink) : document.getElementById(link.hash.slice(1));
        if (!target) { event.preventDefault(); this.refresh(); return; }
        let offset = 24;
        for (const header of document.querySelectorAll('.section-header-sticky, .section-header-sticky-always, sticky-header, .saber-header')) {
          const position = getComputedStyle(header).position;
          if (position === 'sticky' || position === 'fixed') offset = Math.max(offset, header.getBoundingClientRect().height + 16);
        }
        target.style.scrollMarginTop = offset + 'px';
        if (!target.hasAttribute('tabindex')) target.tabIndex = -1;
        // Keep the normal fragment navigation and browser Back behavior.
        target.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onChange, { passive: true });
      this.refresh();
    }
    disconnectedCallback() {
      this.active = false;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame || 0);
      this.frame = 0;
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onChange);
    }
    target(kind, targets = this.scope.querySelectorAll('[data-product-nav-target]')) {
      if (!content[kind]) return null;
      for (const target of targets) {
        if (target.dataset.productNavTarget !== kind || target.dataset.productNavProduct !== this.dataset.productId) continue;
        if (target.dataset.productNavOwner && target.dataset.productNavOwner !== this.dataset.sectionId) continue;
        if (!target.id || target.closest('[hidden]') || !target.getClientRects().length) continue;
        const state = target.dataset.productNavState;
        if (state === 'empty' || state === 'error') continue;
        if (state !== 'pending' && !target.querySelector(content[kind])) continue;
        return target;
      }
      return null;
    }
    refresh() {
      if (!this.active || !this.isConnected) return;
      const targets = this.scope.querySelectorAll('[data-product-nav-target]');
      for (const link of this.links) {
        const target = this.target(link.dataset.productNavLink, targets);
        const hidden = !target;
        if (link.hidden !== hidden) link.hidden = hidden;
        if (target) {
          const href = '#' + target.id;
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        } else if (link.hasAttribute('href')) link.removeAttribute('href');
      }
    }
  }
  customElements.define('saber-product-navigation', ProductNavigation);
})();
